import {formRevision} from './visitaFormUpdatePolicy.js';

export function createVisitaFormUpdater({user,client,fetchRevisions,isAvailable,publish=()=>{},now=Date.now,setTimer=setTimeout,clearTimer=clearTimeout}) {
    let disposed=false,running=null,timer=null,all=false,forced=false;
    const requested=new Set(),pendingIds=new Set(),checked=new Map(),announced=new Map();
    const announce=(id,result)=>{
        const signature=JSON.stringify([result.reason,result.pendingReason,formRevision(result.context),result.context?.visita?.responses_version]);
        if(result.reason==='form_update_pending')pendingIds.add(id);else pendingIds.delete(id);
        if(announced.get(id)!==signature){announced.set(id,signature);publish(id,result);}
    };
    const check=async(ids,{includeNew=false,force=false}={})=>{
        if(disposed||!isAvailable())return [];
        const prepared=await client.prepared();
        const known=new Map(prepared.map(row=>[row.visitaId,row]));
        for(const row of prepared)if(row.candidate||row.hint)pendingIds.add(row.visitaId);
        const targets=[...new Set((ids||[...known.keys()]).map(Number))].filter(id=>Number.isSafeInteger(id)&&id>0&&(includeNew||known.has(id))&&(force||!checked.has(id)||now()-checked.get(id)>30000));
        const results=[];
        for(let offset=0;offset<targets.length;offset+=50){
            const batch=targets.slice(offset,offset+50),data=await fetchRevisions(batch);
            if(disposed||!isAvailable())return results;
            if(data?.schema_version!==1||Number(data.user_id)!==Number(user.id)||Number(data.empresa_id)!==Number(user.empresa_id)||!Array.isArray(data.visitas)||!Array.isArray(data.unavailable_ids))throw Error('No se confirmó la revisión de formularios.');
            const received=[...data.visitas.map(item=>Number(item.visita_id)),...data.unavailable_ids.map(Number)];
            if(received.length!==batch.length||new Set(received).size!==batch.length||received.some(id=>!batch.includes(id))||data.visitas.some(row=>!/^[a-f0-9]{64}$/.test(row.form_revision||'')||!Number.isSafeInteger(row.responses_version)||row.responses_version<0))throw Error('La revisión de formularios está incompleta.');
            for(const id of data.unavailable_ids.map(Number)){
                await client.revoke(id);checked.set(id,now());
                announce(id,{reason:'form_update_pending',pendingReason:'revoked',context:null});
            }
            for(const remote of data.visitas){
                if(disposed||!isAvailable())return results;
                const id=Number(remote.visita_id),local=known.get(id);
                checked.set(id,now());
                const pilotVersionChanged=(local?.mergePilot||local?.candidate?.mergePilot)&&local.responsesVersion!==remote.responses_version;
                if(local?.revision===remote.form_revision&&!pilotVersionChanged){
                    if(local.candidate)await client.forgetCandidate(id,local.candidate.version);
                    if(local.hint)await client.forgetHint(id,local.hint.version);
                    if(pendingIds.has(id))announce(id,{context:await client.read(id),source:'saved'});
                    results.push({visitaId:id,unchanged:true});continue;
                }
                try{
                    await client.noteRevision(id,remote.form_revision);
                    let result;
                    if(local?.candidate?.revision===remote.form_revision&&local.candidate.baseVersion===local.version&&local.candidate.responsesVersion>=remote.responses_version)result=await client.promote(id);
                    if(!result||result.pendingReason==='stale')result=await client.load(id);
                    if(result.reason!=='form_update_pending'&&formRevision(result.context)!==remote.form_revision)result={...result,reason:'form_update_pending',pendingReason:'download_failed'};
                    announce(id,result);results.push({visitaId:id,...result});
                }catch(error){
                    announce(id,{reason:'form_update_pending',pendingReason:'download_failed',context:await client.read(id).catch(()=>null)});
                    results.push({visitaId:id,error});
                }
            }
        }
        return results;
    };
    const run=()=>{
        if(running||disposed||!isAvailable())return running||Promise.resolve();
        const ids=all?null:[...requested],force=forced;all=false;forced=false;requested.clear();
        if(ids?.length===0)return Promise.resolve();
        running=check(ids,{force}).catch(()=>{}).finally(()=>{running=null;if(!disposed&&(all||requested.size)&&isAvailable())schedule();});
        return running;
    };
    const schedule=()=>{if(timer!==null)clearTimer(timer);timer=setTimer(()=>{timer=null;void run();},750);};
    return {check,run,pendingIds,request(ids,{force=false}={}){if(disposed)return;forced=forced||force;if(ids)for(const id of ids)requested.add(Number(id));else all=true;if(isAvailable())schedule();},dispose(){disposed=true;if(timer!==null)clearTimer(timer);client.dispose();}};
}
